import { GlobalStyle } from "../../common/styles/global.js";
import { Navbar } from "../../common/components/Navbar.js";

export const YouLost = () => {
  return (
    <>
      <GlobalStyle />
      <div className="main">
        <div id="mainbox">
          <Navbar />
          <img
            src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZWxtMHhwenltczMzMXMwamlvMDBzMnNmNjU1emdlYWpiZTFrNXFsbiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/cr9vIO7NsP5cY/giphy.gif"
            alt="You Lost"
            width="50%"
            className="center"
          />
        </div>
      </div>
    </>
  );
};
